import React from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import TipoEntrega from "./helpers/TipoEntrega";
import ContentTable from "./ContentTable";
import { getCostString, getTimeStr, getTimeWithHourStr } from "./helpers";
import { getRowsAndTotal } from "../../state/order/actions";
import LockIcon from "@material-ui/icons/Lock";

import Status from "./helpers/Status";
import { getListOrigens, getLabelOrigem } from "../../main/origem";
import consts from "../../main/consts";
import { debounce } from "lodash";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";
import { deliveryNumber } from "../../utils/fields/formatters";

const styles = (theme) => ({
  totalCost: {
    minWidth: 130,
    fontWeight: "bold",
  },
  status: {
    minWidth: 150,
  },
  capitalize: {
    textTransform: "capitalize",
  },
});

const getHeaders = (classes) => [
  {
    title: "Nº Pedido",
    align: "left",
    dataField: "codigoExterno",
    render: (codigoExterno) => codigoExterno.split("#")[0],
  },
  {
    title: "Nº Entrega",
    align: "left",
    dataField: "entregas",
    class: classes.maxWidthCol,
    render: (entregas) => deliveryNumber(entregas[entregas.length - 1].codigo),
  },
  {
    title: "Data",
    align: "left",
    dataField: "dataInclusao",
    render: (data) => getTimeStr(data),
  },
  {
    title: "Entrega estimada",
    align: "left",
    dataField: "dhEntregaEstimada",
    render: (data, row) => salesChannelIsAmericanas(row.canalDeVendas) ? getTimeStr(data) : getTimeWithHourStr(data),
  },
  {
    title: "Cliente",
    align: "left",
    dataField: "cliente",
    class: classes.capitalize,
    render: (data) => data && data.nome.toLowerCase(),
  },
  {
    title: "Canal de venda",
    align: "left",
    dataField: "canalDeVendas",
    render: (data) => data,
  },
  {
    title: "Origem",
    align: "left",
    dataField: "origem",
    filter: "origem",
    filterOptions: getListOrigens(),
    render: (data) => getLabelOrigem(data),
  },
  {
    title: "Tipo de Entrega",
    align: "left",
    dataField: "tipoEntrega",
    render: (data) => (
      <TipoEntrega tipoEntrega={data} aguardandoRetirada={true} />
    ),
  },
  {
    title: "Status",
    align: "center",
    dataField: "status",
    class: classes.status,
    render: (data) => <Status status={data} />,
  },
  {
    title: "Total",
    align: "right",
    dataField: "valorTotal",
    class: classes.totalCost,
    render: (val, { origem }) =>
      origem === "PEGUE_NA_LOJA" ? (
        <LockIcon style={{ color: "#0000008a" }} />
      ) : (
        getCostString(val)
      ),
  },
];

const PAGE_NAME = "all-orders";
const ROWS_PER_PAGE = consts.ROWS_PER_PAGE;
class ProntoSair extends React.Component {
  state = {
    dataInicial: null,
    dataFinal: null,
    order: null,
    orderBy: null,
    find: (this.props.location.state && this.props.location.state.find) || "",
  };

  componentDidMount() {
    this.loadGridData(0, ROWS_PER_PAGE, true);
  }

  componentDidUpdate(prevProps) {
    const {
      loja,
      orders: { filters },
      limit,
    } = this.props;

    if (
      loja !== prevProps.loja ||
      filters !== prevProps.orders.filters ||
      prevProps.limit !== limit
    ) {
      this.loadGridData(0, ROWS_PER_PAGE, true);
    }
  }

  loadGridData = (page, limits, avoidSpinner = false) => {
    const {
      getRowsAndTotal,
      orders: { filters },
      limit,
    } = this.props;
    const { order, orderBy, ...stateFilters } = this.state;

    limits = limits || ROWS_PER_PAGE;

    getRowsAndTotal({
      page,
      limit: limit,
      filters: { ...filters, ...stateFilters },
      avoidSpinner,
      pageId: PAGE_NAME,
    });
  };

  clickRow = (row) => {
    this.props.history.push(`${consts.CONTEXT}/all-orders/${row.numero}`, {
      data: { page: PAGE_NAME },
    });
  };

  handleOrderChange = (ordering) => {
    this.setState({ order: ordering.order, orderBy: ordering.orderBy }, () =>
      this.loadGridData(0, null, true)
    );
  };

  handleFilterChange = (find) => {
    this.setState({ find }, () => this.debouncedSearch(find));
  };

  debouncedSearch = debounce((find) => {
    (find.length >= 3 || find.length === 0) &&
      this.loadGridData(0, null, false);
  }, 600);

  handleDateChange = (e) => {
    const { _d: date } = e || {};
    if (!date || !isNaN(date)) {
      this.setState({ dataInicial: date, dataFinal: date }, () =>
        this.loadGridData(0, null, true)
      );
    }
  };

  render() {
    const { dataInicial, find } = this.state;

    return (
      <ContentTable
        loaded={this.props.orders.loaded}
        limit={this.props.limit}
        title="Todos os Pedidos"
        subtitle=""
        page={PAGE_NAME}
        headers={getHeaders(this.props.classes)}
        onClickRow={this.clickRow}
        rows={this.props.orders.grids[PAGE_NAME].rows}
        total={this.props.orders.grids[PAGE_NAME].total}
        selectedPage={this.props.orders.page}
        rowsPerPage={ROWS_PER_PAGE}
        showPaginator={false}
        onHandlePageChange={this.loadGridData}
        filter={{
          enable: true,
          dataInicial,
          query: find,
          find,
          handleOrderChange: this.handleOrderChange,
          handleFilterChange: this.handleFilterChange,
          handleDateChange: this.handleDateChange,
        }}
        selectedOrigemFilter={getLabelOrigem(
          this.props.orders.grids[PAGE_NAME].selectedFilter
        )}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    loja: state.auth.loja,
    limit: state.orders.limit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getRowsAndTotal }, dispatch);
};
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ProntoSair);
